/**
 * AntiLockInStrip — extracted from Landing.js (Feb 14 2026)
 * Inline strip listing the 3 anti-lock-in promises. Full 3-card grid + contract
 * clauses still live at /security. Pure presentational, no state.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, Check, ArrowRight } from 'lucide-react';

export default function AntiLockInStrip() {
  return (
    <section className="py-10 px-4 border-t border-white/5" data-testid="anti-lock-in-strip">
      <div className="max-w-5xl mx-auto rounded-2xl border border-emerald-500/20 bg-slate-900 px-5 py-4 sm:px-7 sm:py-5">
        <div className="flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-7">
          <div className="flex items-center gap-3 shrink-0">
            <div className="w-11 h-11 rounded-xl bg-emerald-500 shadow-lg shadow-emerald-500/40 flex items-center justify-center">
              <Lock className="w-5 h-5 text-white drop-shadow-[0_0_4px_rgba(255,255,255,0.55)]" />
            </div>
            <div className="leading-tight">
              <div className="text-[10px] font-mono uppercase tracking-[0.22em] text-emerald-300">Anti-Lock-In</div>
              <div className="text-sm font-bold text-white">3 promises. In every contract.</div>
            </div>
          </div>
          <ul className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-5 flex-1 text-[13px] text-slate-300">
            <li className="flex items-center gap-2"><Check className="w-4 h-4 text-emerald-400 shrink-0" /> Your data is yours <span className="text-slate-500">·</span> <span className="text-slate-500">7-day export</span></li>
            <li className="flex items-center gap-2"><Check className="w-4 h-4 text-emerald-400 shrink-0" /> Costs are open <span className="text-slate-500">·</span> <span className="text-slate-500">/pricing-math</span></li>
            <li className="flex items-center gap-2"><Check className="w-4 h-4 text-emerald-400 shrink-0" /> Cancel any time <span className="text-slate-500">·</span> <span className="text-slate-500">no email needed</span></li>
          </ul>
          <Link
            to="/security"
            data-testid="anti-lock-in-strip-cta"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-emerald-300 hover:text-emerald-200 shrink-0"
          >
            Read contract <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
